// ─── DaData suggestion shape ──────────────────────────────────────────────────

export interface DadataSuggestion {
  value: string;
  data: Record<string, unknown>;
}

// ─── Form state ───────────────────────────────────────────────────────────────

export interface LegalFormData {
  // Step 1
  orgSearch: string;
  legalName: string;
  legalFullName: string;
  orgForm: string;
  inn: string;
  ogrn: string;
  kpp: string;
  billingDescriptor: string;
  legalEmail: string;
  siteUrl: string;
  // Step 2
  addressSearch: string;
  legalCountry: string;
  city: string;
  street: string;
  building: string;
  office: string;
  postalCode: string;
  // Step 3
  directorLastName: string;
  directorFirstName: string;
  directorMiddleName: string;
  directorPhone: string;
  directorCitizenship: string;
  // Step 4
  bankSearch: string;
  bankName: string;
  bik: string;
  corrAccount: string;
  settlementAccount: string;
  bankPaymentDetails: string;
  // Self-employed
  selfFullName: string;
  selfInn: string;
  selfPhone: string;
  selfPassportSeries: string;
  selfPassportNumber: string;
  selfPassportIssuedBy: string;
  selfPassportDate: string;
}

export const INITIAL_FORM: LegalFormData = {
  orgSearch: "",
  legalName: "",
  legalFullName: "",
  orgForm: "",
  inn: "",
  ogrn: "",
  kpp: "",
  billingDescriptor: "",
  legalEmail: "",
  siteUrl: "",
  addressSearch: "",
  legalCountry: "RUS",
  city: "",
  street: "",
  building: "",
  office: "",
  postalCode: "",
  directorLastName: "",
  directorFirstName: "",
  directorMiddleName: "",
  directorPhone: "",
  directorCitizenship: "RUS",
  bankSearch: "",
  bankName: "",
  bik: "",
  corrAccount: "",
  settlementAccount: "",
  bankPaymentDetails: "",
  selfFullName: "",
  selfInn: "",
  selfPhone: "",
  selfPassportSeries: "",
  selfPassportNumber: "",
  selfPassportIssuedBy: "",
  selfPassportDate: "",
};

// ─── Raw API data shapes ──────────────────────────────────────────────────────

export interface RawLegalData {
  isLegalDataFilled?: boolean;
  legal_name?: string;
  legal_full_name?: string;
  inn?: string;
  kpp?: string;
  ogrn?: string;
  billing_descriptor?: string;
  legal_email?: string;
  site_url?: string;
  legal_zip?: string;
  legal_country?: string;
  legal_city?: string;
  legal_street?: string;
  office?: string;
  director_first_name?: string;
  director_last_name?: string;
  director_middle_name?: string;
  director_phone?: string;
  director_citizenship?: string;
  settlement_account?: string;
  correspondent_account?: string;
  bank_name?: string;
  bik?: string;
  bank_payment_details?: string;
  orgForm?: string;
  tbank_registered_at?: string | null;
}

export interface RawContractorData {
  contractor_full_name?: string;
  contractor_inn?: string;
  contractor_phone?: string;
  contractor_passport_series?: string;
  contractor_passport_number?: string;
  contractor_passport_issued_by?: string;
  contractor_passport_issue_date?: string;
}

export function hasData(obj: unknown): boolean {
  if (!obj || typeof obj !== "object") return false;
  return Object.values(obj as Record<string, unknown>).some(
    (v) => v !== null && v !== undefined && v !== "",
  );
}
